import React, { useState } from "react";
import "./styles.scss";

const Welcome = () => {
  return (
    <div className="welcome d-flex-center flex-column">
      <h1 className="title-03 text-center">Bienvenidos a la página de</h1>
      <h1 className="title-03 text-center title-red">
        <b>Gestión de Proveedores</b>
      </h1>
    </div>
  );
};

export default Welcome;
